import React from 'react'
import injectSheet from 'react-jss'
import styles from './create-dialog.styles'
import { Modal, ModalHeader, ModalFooter } from 'pobble-components/dist/modal'
import Button from 'pobble-components/dist/button'
import SlideForm from '../slide-form/slide-form'

const VideoSlideCreateDialog = ({
  classes,
  modalOpened,
  onChange,
  onClose,
  onSubmit,
  onLinkChange,
  disableSubmit
}) => {
  return (
    <Modal closeButton isOpen={modalOpened} requestClose={onClose}>
      <ModalHeader>Add YouTube video slide</ModalHeader>
      <SlideForm
        onSubmit={onSubmit}
        initialValues={{
          title: '',
          text: '',
          url: ''
        }}
        footer={() => (
          <ModalFooter alignRight childrenGap>
            <Button action={onClose} tall simple>
              Cancel
            </Button>
            <Button tall type="submit">
              Create slide
            </Button>
          </ModalFooter>
        )}
      />
    </Modal>
  )
}

export default injectSheet(styles)(VideoSlideCreateDialog)
